<ion-list [ngClass]="config.class? config.class : ''">

  <ng-container *ngFor="let item of formattedList; let i = index">

    <app-list-item [listConfig]="config" [item]="item" [data]="data" [parentListLevel]="level" [listIndex]="listIndex? (listIndex+'_'+i): i" [config]="item.config" [listItemData]="item.listData"></app-list-item>

  </ng-container>

</ion-list>
